import SpecialSalaryPatternAddPage from './SpecialSalaryPatternAddPage';

export default SpecialSalaryPatternAddPage;
